import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ClientsGoalsRoute extends Route {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('account-progress') declare accountProgress: Service.AccountProgress;
	@service('request') declare requestService: Service.Request;
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;

	private goalViewed = false;

	override beforeModel() {
		// non-blocking
		void this.mmGoalsService.requestClientGoalsData();

		return this.mmGoalsService.requestClientGoals();
	}

	override afterModel() {
		if (this.billingService.goalsEnabled) {
			if (!this.accountProgress.isAllDone && !this.goalViewed) {
				this.requestService
					.api('POST', '/account-progress/goal-viewed', null, { withoutPrefix: true })
					.catch(this.requestService.handleGenericThrownError.bind(this.requestService));

				this.goalViewed = true;
			}
		} else {
			this.navigationService.transitionToRoute('goals.index');
		}
	}
}
